// src/components/Admin/CategoryFormModal.js
"use client";

import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import api from "../../services/api";
import { toast } from "react-toastify";

const CategoryFormModal = ({ show, onHide, category, onSuccess }) => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (category) {
      setName(category.name || "");
    } else {
      setName("");
    }
  }, [category]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (category) {
        // ویرایش
        await api.patch(`/admin/categories/${category.id}`, { name });
        toast.success("دسته ویرایش شد");
      } else {
        // افزودن جدید
        await api.post("/admin/categories", { name });
        toast.success("دسته جدید اضافه شد");
      }
      onSuccess();
      onHide();
    } catch (err) {
      toast.error(err.response?.data?.message || "خطا در ذخیره دسته");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{category ? "ویرایش دسته" : "افزودن دسته"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>نام دسته</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>انصراف</Button>
          <Button type="submit" variant="primary" disabled={loading}>
            {loading ? "در حال ذخیره..." : "ذخیره"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CategoryFormModal;
